export function issueSummaryFields(summary) {
    const open = summary?.open_issue_count;
    const blocked = summary?.blocked_issue_count;
    const known = Number.isInteger(open) && open >= 0 && Number.isInteger(blocked) && blocked >= 0;
    return {
        open_issue_count: known ? open : undefined,
        blocked_issue_count: known ? blocked : undefined,
    };
}

export function summarizeReports(reports) {
    const summary = {open_issue_count: 0, blocked_issue_count: 0};
    for (const report of reports) {
        const status = (report.status ?? 'OPEN').toUpperCase();
        if (status === 'OPEN') summary.open_issue_count += 1;
        else if (status === 'BLOCKED') summary.blocked_issue_count += 1;
        else if (status !== 'CLOSED') return undefined;
    }
    return summary;
}

export function issueAppearance(summary) {
    const {open_issue_count: open, blocked_issue_count: blocked} = issueSummaryFields(summary);
    if (open === undefined) return {color: 'grey', title: 'Property Issues: status unavailable'};
    if (open > 0) return {color: 'red', title: `Property Issues: ${open} open, ${blocked} blocked`};
    if (blocked > 0) return {color: '#9a6700', title: `Property Issues: ${blocked} blocked`};
    return {color: 'green', title: 'Property Issues: no pending issues'};
}

// A list read can finish after a Report mutation. Keep property updates made
// since that read started; a later fresh list read can replace them normally.
export function createIssueSummaryTracker() {
    let revision = 0;
    const updates = new Map();
    return {
        getRevision: () => revision,
        record(propertyId, summary) {
            updates.set(String(propertyId), {revision: ++revision, fields: issueSummaryFields(summary)});
        },
        apply(jobs, sinceRevision) {
            return jobs.map(job => {
                const update = updates.get(String(job.property_id));
                return update && update.revision > sinceRevision ? {...job, ...update.fields} : job;
            });
        },
    };
}
